import { firestore } from "../firebase/firestore"

export const getConsumerUnit = (id) => {
    return firestore.collection('consumer_units').doc(id).get()
};

export const getActiveConsumerUnitByCPF = (cpf) => {
    return firestore.collection('consumer_units').where('cpf', '==', cpf).where('status', 'in', ['activated', 'canceling', 'interrupted', 'interruting']).limit(1).get()
};

export const cpfExists = (cpf) => {
    const unformattedCPF = cpf ? cpf.replace(/\D/g, '') : ''
    return firestore.collection('users')
        .where('cpf', 'in', [cpf, unformattedCPF])
        .limit(1)
        .get()
        .then(query => {
            if(query.empty) return false

            if(
                query.docs.length === 1 &&
                query.docs[0].data()?.status?.toString().toUpperCase() === 'ONBOARDING'
            ) {
                return false
            }

            return true
        })
};

export const getActiveConsumerUnitByCustomerId = (customer_id) => {
    return firestore.collection('consumer_units').where('user_id', '==', customer_id).where('status', 'in', ['activated', 'canceling', 'interrupted', 'interruting']).limit(1).get()
};